import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { AnnouncementSection } from "@/components/AnnouncementSection";
import { CategoryGrid } from "@/components/CategoryGrid";
import { Footer } from "@/components/Footer";
import { SeoHead } from "@/components/SeoHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Øutlaws Vault | Premium South African Automotive Lifestyle"
        description="Outlaws Vault is a premium South African automotive lifestyle platform. Shop exclusive drops, join elite events, and connect with a community built on performance."
        path="/"
      />
      <Navigation />
      <main>
        <HeroSection />
        <AnnouncementSection />
        <CategoryGrid />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
